import React, { useState, useEffect, useRef, Fragment } from "react";

// Librerias de componentes
import { Dialog } from "primereact/dialog";
import { classNames } from "primereact/utils";
import { Checkbox } from "primereact/checkbox";
import { Accordion, AccordionTab } from "primereact/accordion";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import { TabView, TabPanel } from 'primereact/tabview';

import { toastShow } from "../../../../Services/ToastService";
import { changePermisos, getPermisos } from "../../../../API/IT/Permisos/PermisosRequests";
import { getMenus } from "../../../../API/IT/Menu/MenuRequests";
import { getListAccesoMenu } from "../../../../API/IT/Accesos/AccesosRequests";
import { getAccesosUser, updateAccesoUser } from "../../../../API/IT/Usuarios/AccesosUserRequets";
import Icon from '../../../../Components/icon/Icon';


// import "./ModalStyle.scss"


export const ModalEditarAccesosPermisos = ({
  accessPermissionEdit,
  setaccessPermissionEdit,
  getUsers,
  modalRoles = false,
}) => {
  // Variables necesarias
  const [listAcceso, setListAcceso] = useState([]);
  const [showDialog, setShowDialog] = useState(false);

  // const [formData, setFormData] = useState();

  const [usuarioDialog, setUsuarioDialog] = useState(false);
  const toast = useRef(null);

  const [menu, setMenu] = useState([]);
  const [permisos, setPermisos] = useState([]);
  const [accesosUser, setAccesosUser] = useState([]);

  const [isLoading, setIsLoading] = useState(false);



  // *******************   PERMISOS POR USUARIOS    ************************
  const getPermisosUsuario = async (IdUser) => {
    setIsLoading(true);
    const resp = await getPermisos(IdUser);
    const ac = await getAccesosUser(IdUser);

    // console.log('--------------OBTENCION PERMISOS-------------',resp)
    // console.log('-------------OBTENCION ACCESOS--------------',ac)

    if (ac.length > 0) {
      setAccesosUser(ac[0].AccessWeb ? ac[0].AccessWeb.split(",").sort() : []);
    }
    if (resp?.code === "EREQUEST") {
      toastShow(toast, "error", "Error", "Error al obtener los permisos");
      setIsLoading(false);
    } else {
      setIsLoading(false);
      const ordenado = resp[0]?.PermissionMenu
        ? resp[0].PermissionMenu.split(",").sort()
        : [];
      setPermisos(ordenado);
    }
  };
  

  const setSubMenu = (base, menuTempo) => {
    return base.map((item, i) => {
      let subNivel = [];
      let t = menuTempo.filter(
        (element) => element.IdContainer === item.IdMenu
      );
      let subs = [];
      t.map((e) =>
        menuTempo.forEach((element) => {
          if (element.IdContainer === e.IdMenu) {
            subs.push(element);
          }
        })
      );
      subNivel = [...t, ...subs];

      let subNiveles = [];
      subNivel.forEach((subItem, i) => {
        subNiveles.push(checkbox(subItem));
      });

      return getNivelEncabezado(item, subNiveles);
    });
  };

  const getInfo = async () => {
    const menuTempo = await getMenus();
    const t = await getListAccesoMenu();
    if (t.length > 0) {
      setListAcceso(t);
    }
    let html = "";
    const base = menuTempo.filter((element) => element.IdContainer === 0);
    html = setSubMenu(base, menuTempo);
    setMenu(html);
  };

  const getNivelEncabezado = (item, subNiveles) => {
    return (
      <AccordionTab
        key={item.IdMenu}
        header={
          <React.Fragment>
            <div className="modal__permisosCheck">
              <span>
              <Icon icon={item.Icon ? item.Icon : 'a'} />
                {' ' + item.Menu}
              </span>
              <span className="mx-3">
                <Checkbox
                  value={item.IdMenu}
                  onChange={onPermisosSubNivelChange}
                  checked={permisos.some(
                    (IdMenu) => IdMenu === item.IdMenu + ""
                  )}
                />
              </span>
            </div>
          </React.Fragment>
        }
      >
        <div className="gridCheckbox">{subNiveles}</div>
      </AccordionTab>
    );
  };

  const checkbox = (subNivel) => {
    return (

      <div key={subNivel.IdMenu} className="field-checkbox">
        <Checkbox
          inputId={subNivel.IdMenu + 'P'}
          name="category"
          value={subNivel.IdMenu}
          onChange={onPermisosSubNivelChange}
          checked={permisos.some((item) => item === subNivel.IdMenu + "")}
        />
        <label htmlFor={subNivel.IdMenu + 'P'}>{subNivel.Menu}</label>
      </div>
    );
  };

  const showAccesos = () => {
    return (
      <Accordion
        className={classNames("accordion-custom modal_accordion", {
          isNotVisible: isLoading,
        })}
        multiple
      >
        {listAcceso.map((menu) => (
          <AccordionTab  key={menu.IdMenu}  header={menu.Menu}>
            <div className="gridCheckbox">
              {menu.Access.map((acceso) => (
                <div key={acceso.IdAccess} className="field-checkbox">
                  <Checkbox
                    inputId={acceso.IdAccess + 'A'}
                    name="category"
                    value={acceso.IdAccess}
                    onChange={changeAccesoUsuario}
                    checked={accesosUser.some(
                      (item) => item === acceso.IdAccess + ""
                    )}
                  />
                  <label className="px-2" htmlFor={acceso.IdAccess + 'A'}>
                    {acceso.Access}
                  </label>
                </div>
              ))}
            </div>
          </AccordionTab>
        ))}
      </Accordion>
    );
  };

  const changeAccesoUsuario = async (e) => {
    const aquiEstoy = accesosUser.some((item) => item === e.value + "");
    let newAccesos = null;
    if (aquiEstoy) {
      newAccesos = accesosUser.filter((item) => item !== e.value + "");
    } else {
      if (accesosUser[0] === "") {
        newAccesos = [e.value + ""];
      } else {
        newAccesos = [...accesosUser, e.value + ""];
      }
    }
    const result = await updateAccesoUser({
      AccessWeb: newAccesos.sort().toString(),
      IdUser: accessPermissionEdit.IdUser,
    });
    if (result.length > 0) {
      // setAccesosUser(result[0].AccessWeb.split(",").sort());
      setAccesosUser(result[0].AccessWeb ? result[0].AccessWeb.split(",").sort() : []);
    }
  };


  const onPermisosSubNivelChange = async (e) => {
    const aquiEstoy = permisos.some((item) => item === e.value + "");

    let newPermisos = null;
    if (aquiEstoy) {
      newPermisos = permisos.filter((item) => item !== e.value + "");
    } else {
      if (permisos[0] === "") {
        newPermisos = [e.value + ""];
      } else {
        newPermisos = [...permisos, e.value + ""];
      }
    }
    const result = await changePermisos({
    PermissionMenu: newPermisos.sort().toString(),
      IdUser: accessPermissionEdit.IdUser,
    });
    if (result.length > 0) {
      setPermisos(result[0].PermissionMenu ? result[0].PermissionMenu.split(",").sort() : []);
    }
  };





  
  // UseEffect que obtiene las datos de las funciones para getRoles y getEstados para mostrar
  // la informacion en los Dropdown (Select de opciones)
  useEffect(() => {
    if (usuarioDialog) {
      getInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permisos, accesosUser, usuarioDialog]);


  const onHide = () => {
    setUsuarioDialog(false);
    setShowDialog(false);
    setaccessPermissionEdit(null);
  };

  useEffect(() => {
    if (accessPermissionEdit) {
      getInfo();
      setUsuarioDialog(true);
      getPermisosUsuario(accessPermissionEdit.IdUser);

    }
    if (accessPermissionEdit) {
      setShowDialog(true);
    } else {
      setShowDialog(false);
    }
  }, [accessPermissionEdit]);

  
  return (
    <Fragment>
      <div className="form-demo">
        <Toast position="bottom-right" ref={toast} />
        <div className="flex justify-content-center">
          <Dialog
            id="editModal1"
            visible={showDialog}
            header="Editar Accesos y Permisos"
            className="modal__contenedor modal__usuarios"
            onHide={onHide}
          >
            <form className="p-fluid" style={{ margin: "Auto" }}>
              <TabView>
                <TabPanel header="Permisos por usuario">
                  <div className="modal__input-contenedor">
                    <h3 className="modal_texto-titulo-permisos">
                      Permisos por usuario
                    </h3>
                  </div>
                  <div className="modal__input-contenedor">
                    <div
                      className={classNames("progressSpinner-container", {
                        isVisible: isLoading,
                      })}
                    >
                      <ProgressSpinner></ProgressSpinner>
                    </div>
                    <Accordion
                      className={classNames(
                        "accordion-custom modal_accordion",
                        {
                          isNotVisible: isLoading,
                        }
                      )}
                      multiple
                    >
                      {menu}
                    </Accordion>
                  </div>
                </TabPanel>
                <TabPanel header="Accesos por usuario">
                  {listAcceso.length > 0 && (
                    <div>
                      <div className="modal__input-contenedor">
                        <h3 className="modal_texto-titulo-permisos">
                          Accesos por usuario
                        </h3>
                      </div>
                      <div className="modal__input-contenedor">
                        {showAccesos()}
                      </div>
                    </div>
                  )}
                </TabPanel>
              </TabView>
            </form>
          </Dialog>
        </div>
      </div>
    </Fragment>
  );


};

export default ModalEditarAccesosPermisos;

